import { headerHeight } from '../helpers/header-height';
import { Scroll } from '../helpers/scroll';

export class Tabsmenu {

	constructor(elem) {
		this.elem = elem;

		this.tabsBar = document.querySelector('div[data-tabsmenu] ul');
		this.tabs = document.querySelectorAll('div[data-tabsmenu] a[href*="#"]');
		this.sections = document.querySelectorAll('a[id], div[id]');

		this.lastId = '';
		this.lastIndex = '-1';

		this.setClassOnSection();
		this.addEventHandlers();
	}

	static getSelector() {
		return '[data-tabsmenu]';
	}

	addEventHandlers() {
		window.addEventListener('scroll', () => {
			this.setClassOnSection();
		});
	}

	isSmallScreen() {
		return this.tabsBar.scrollWidth > window.innerWidth;
	}

	setClassOnSection() {
		let cur;
		let curId;

		const siteHeaderHeight = headerHeight.setSiteHeaderHeight();
		const eventHeaderHeight = headerHeight.setEventsPageHeaderHeight();

		const headerDifference = this.isSiteHeaderVisible() ? siteHeaderHeight + eventHeaderHeight : eventHeaderHeight;

		for (let i = 0; i < this.sections.length; i++) {
			if (this.sections[i].getBoundingClientRect().top - headerDifference < 20) {
				cur = this.sections[i];
				curId = cur.id;
			}
		}

		if (this.lastId !== curId) {
			this.lastId = curId;
			for (let i = 0; i < this.tabs.length; i++) {
				if (this.tabs[i].getAttribute('href') === '#' + curId) {
					this.setActiveClass(i);
				}
				if (curId === undefined && this.lastIndex >= 0) {
					this.tabs[this.lastIndex].classList.remove('active');
				}
			}
		}
	}

	setActiveClass(i) {
		if (this.lastIndex >= 0) {
			this.tabs[this.lastIndex].classList.remove('active');
		}
		this.lastIndex = i;

		this.tabs[i].classList.add('active');

		if (this.isSmallScreen()) {
			this.scrollTabsBar(i);
		}
	}

	scrollTabsBar(item) {
		const windowWidth = window.innerWidth;
		const scrolledPos = this.tabsBar.scrollLeft;
		const itemLeftBorderOffset = this.tabs[item].offsetLeft;
		const itemWidth = this.tabs[item].clientWidth;
		const itemRightBorderOffset = itemLeftBorderOffset + itemWidth;

		if (itemRightBorderOffset > windowWidth) {
			Scroll.scrollTo(this.tabsBar, itemRightBorderOffset - windowWidth + 25, 200);
		}

		if (scrolledPos + 25 > itemLeftBorderOffset) {
			Scroll.scrollTo(this.tabsBar, itemLeftBorderOffset - 25, 200);
		}
	}

	isSiteHeaderVisible(){
		return document.body.classList.contains('_has-visible-header');
	}
}

